import type { AppProps } from "next/app";
import { DefaultSeo } from "next-seo";
import { defaultSeoSettings } from "lib/defaultMetadata";
import { ThemeProvider } from "next-themes";

import { atom, RecoilRoot } from "recoil";
import { initFirebase } from "lib/firebase";
import { CurrentUser } from "lib/type";
import { useAuth } from "hooks/useAuth";

import "tailwindcss/tailwind.css";
import "styles/global.scss";
import "styles/search.scss";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

export const userState = atom<CurrentUser>({
  key: "user",
  default: undefined,
});

const AppInit = () => {
  initFirebase();
  useAuth();
  return null;
};

const MyApp = ({ Component, pageProps }: AppProps) => {
  return (
    <RecoilRoot>
      <DefaultSeo {...defaultSeoSettings} />
      <ThemeProvider attribute="class">
        <Component {...pageProps} />
      </ThemeProvider>
      <AppInit />
    </RecoilRoot>
  );
};

export default MyApp;
